<!-- <div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title" *ngIf="payrollDefinition?.payrollName != 'Flexible Time Entry (Daily)'">{{data.title}}</h4>
    <h4 mat-dialog-title class="dialog-title" *ngIf="payrollDefinition?.payrollName === 'Flexible Time Entry (Daily)'">{{data.title}}</h4>
    <div mat-dialog-content class="dialog-content text-muted">{{data.content}}</div>
    <div mat-dialog-actions class="dialog-actions mt-4 text-right">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        <button mat-button class="yes-button" *ngIf="payrollDefinition?.payrollName != 'Flexible Time Entry (Daily)'" (click)="insertTime()" cdkFocusInitial>{{data.confirmText}}</button>
        <button mat-button class="yes-button" *ngIf="payrollDefinition?.payrollName === 'Flexible Time Entry (Daily)'" (click)="insertFlexiTime()" cdkFocusInitial>{{data.confirmText}}</button>
    </div>
</div> -->
<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{data.title}}</h4>
    <div mat-dialog-content class="dialog-content text-muted">{{data.content}}</div>
    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        <button mat-button class="yes-button" (click)="submitTimeSheet(data.timeSheetID)" [disabled]="isLoading" cdkFocusInitial>
            <ng-container *ngIf="!isLoading; else loading">
                {{data.confirmText}}
            </ng-container>
            <ng-template #loading>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </ng-template>
        </button>
    </div>
</div>